import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { AuthService } from '../../services/auth.service';

const publicRoutes = [
  '/explore',
  '/auth/login',
  '/sendmail-info',
  '/celebrities/domaines',
  '/verify-email',
  '/',       // Sans hash
  '/#/'      // Avec hash
];

export const AuthGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const token = localStorage.getItem('token');
  const destinationUrl = state.url.split('?')[0]; // Supprime les paramètres GET

  console.log('🔹 Vérification AuthGuard - URL:', destinationUrl, '| Token présent:', !!token);

  // Convertir les URLs pour être plus flexibles
  const normalizedUrl = destinationUrl.replace(/^\/#/, '/'); // Enlève le "#"
  
  if (publicRoutes.includes(normalizedUrl)) {
    console.log('AuthGuard - Route publique détectée:', normalizedUrl);
    return true;
  }

  if (!token) {
    console.log('AuthGuard - Pas de token, redirection vers /auth/login');
    router.navigate(['/auth/login']);
    return false;
  }

  console.log('AuthGuard - Accès autorisé:', normalizedUrl);
  return true;
};


export const AdminGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isAdmin().pipe(
    take(1),
    map(isAdmin => {
      if (!isAdmin) {
        router.navigate(['/admin/login']);
      }
      return isAdmin;
    })
  );
};
